import type { ReactNode } from 'react';

export const symbol_book_6: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-80q-50 0-85-35t-35-85v-560q0-50 35-85t85-35h360q24.75 0 42.38 17.62Q660-844.75 660-820v500q0 24.75-17.62 42.37Q624.75-260 600-260H240q-25.5 0-42.75 17.5T180-200q0 25 17.25 42.5T240-140h540v-630q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v630q0 24.75-17.62 42.37Q804.75-80 780-80H240Zm0-240h360v-500H240q-25.5 0-42.75 17.25T180-760v457q13-8 27.88-12.5Q222.77-320 240-320Zm52.09-100q8.34 0 14.08-4t7.83-11l20-56h113l18.82 56.21q1.89 6.9 7.53 10.85Q479-420 486.5-420q12.86 0 20.18-10t2.32-21l-88.86-234q-2.02-7-8.08-11-6.06-4-13.89-4h-17.63q-7.83 0-13.71 4-5.87 4-7.83 11l-88 235q-5 11 1.78 20.5 6.79 9.5 19.31 9.5ZM348-532l41.49-116h2.02L433-532h-85ZM180-303v-517 517Z"
		/>
	</svg>
);
